import { Helmet } from 'react-helmet-async';

export const Head = ({ title }: { title?: string }) => {
  return (
    <Helmet>
      <title>{title || 'ONE-Story'}</title>
    </Helmet>
  );
};
